export default "__VITE_ASSET__DPaHFxop__"